"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../hooks");
const useStyles = props => {
  const {
    pxToRem,
    scrollProps
  } = (0, _hooks.useStylesUtils)();
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    isFullScreen,
    isWithActionButtons,
    options
  } = props;
  const ccMenuDropMenuStyle = (0, _react.useMemo)(() => {
    const deviceProps = () => {
      const otherContentHeight = isWithActionButtons ? pxToRem(144) : pxToRem(60);
      const maxHeight = isMobileView ? isFullScreen ? `calc(100vh - ${otherContentHeight})` : `calc(80vh - ${otherContentHeight})` : pxToRem(options ? 256 : 370);
      const padding = isMobileView ? `${pxToRem(0)} ${pxToRem(8)}` : `${pxToRem(0)} ${pxToRem(2)}`;
      return {
        maxHeight,
        padding
      };
    };
    const ccMenuDropMenu = (0, _css.css)({
      overflow: 'auto',
      ...deviceProps(),
      ...scrollProps()
    });
    return {
      ccMenuDropMenu
    };
  }, [isFullScreen, isMobileView, isWithActionButtons, options, pxToRem, scrollProps]);
  return {
    'cc-Menu__dropMenu': ccMenuDropMenuStyle.ccMenuDropMenu
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;